module.exports = __webpack_public_path__ + "img/symbol_6.ee0fa802.png";